// prettier-ignore

export const EU = require("./data/eu.json");
